import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/1/002.jpg';
import img2 from './images/portfolio/parties-and-events/001.jpg';
import img3 from './images/portfolio/family-and-kids/052.jpg';
import img4 from './images/portfolio/vips-politicians-and-bigshots/Ashanti_img_107.jpg';
import img5 from './images/portfolio/vips-politicians-and-bigshots/Img_072.jpg';
import img6 from './images/portfolio/portraits/IMG_022.jpg';
import img7 from './images/portfolio/family-and-kids/DSC_0051.jpg';
import img8 from './images/portfolio/parties-and-events/IMG0089.jpg';
import img9 from './images/portfolio/commercial-photography/Mansion.jpg';
import img10 from './images/portfolio/parties-and-events/IMG0546.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
];

function Home() {
    return <Slides images={images}/>;
}

export default Home;
